import React from 'react';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import VideoPreview from 'modules/core/components/videoPreview';
import HttpClient from 'services/HttpClient';
import NoResults from 'modules/blocks/noResults';
import {inject, observer} from 'mobx-react';

const SEARCH_REQUEST = '/api/v1/search_tutorials/?title=';

@withRouter
@inject('userStore')
@observer
export default class SearchComponent extends React.Component {

  state = { tutorials: [], searchQuery: '' };

  componentDidMount(){
    this.handleChangeRoute(this.props.location);
    this.listener = this.props.history.listen( (location) => {
      this.handleChangeRoute(location)
    })
  }

  handleChangeRoute = location => {
    let title = location.pathname.split('/search/')[1];
    new HttpClient().get(SEARCH_REQUEST + title).then(response => {
      this.setState({tutorials: response.body.data.tutorials, searchQuery: title})
    })

  };

  videoDurationTime = intTime => {
    let minutes = parseInt(intTime / 60);
    let seconds = parseInt(intTime % 60);
    return `${minutes}:${seconds}`;
  };

  componentWillUnmount(){
    this.listener();
  }

  render(){

    const categories =  this.state.tutorials.map( item => {
      return (
        <div className="col-md-4"
             key={item.id}>
          <Link to={this.props.userStore.user ? `/tutorial/${item.slug}` : '/pricing'}>
            <VideoPreview
              placeholder={{img: item.thumbnail_url}}
              title={item.title}
              categoryId={this.props.itemId}
              itemId={item.id}
              stubKey={item.stubKey}
              type={{url: `/categories/?slug=${item.category_slug}`, name: item.category_title}}
              time={this.videoDurationTime(item.duration_time)}
              isAdmin={false}
              viewed={item.viewed}/>
          </Link>
        </div>
      )
    });

      if(this.state.tutorials.length > 0)
        return (
      <section className="section categories">

        <div className="container-fluid" style={{paddingTop: 40}}>
          <div className="col-md-4">
          {this.state.searchQuery &&
          <p className="search-text">«{this.state.searchQuery}»</p>
          }
          <p className="search-count" style={{paddingTop: this.state.searchQuery ? 'initial' : 20}}>{this.state.tutorials.length} results</p>
        </div>
          {categories}
        </div>
      </section>
    );
    else return <NoResults title={this.state.searchQuery}/>
  }
}



// WEBPACK FOOTER //
// ./src/modules/search/SearchComponent.js